import { Search } from 'lucide-react';

// Piezas de la fila de filtros, en el mismo orden y lugar en todos los
// módulos: el usuario aprende una pantalla y sabe usar las catorce.
//
// NINGUNA TENÍA NOMBRE. El texto que las identifica era el `placeholder`
// —que desaparece en cuanto se escribe— o directamente nada. Como se usan
// en los catorce módulos, arreglarlo aquí lo arregla en todos.

export function Buscador({ valor, onChange, placeholder = 'Buscar…', etiqueta }) {
  return (
    <div className="relative">
      <Search className="h-4 w-4 text-gray-500 absolute left-2.5 top-2.5" aria-hidden="true" />
      <input
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        // Un `placeholder` NO es una etiqueta: se borra al teclear, y
        // entonces el campo se queda sin nada que lo identifique.
        aria-label={etiqueta || placeholder}
        className="pl-8 pr-3 py-2 text-sm border border-gray-300 rounded-lg w-56 bg-white focus:border-[var(--color-marca)] focus:ring-2 focus:ring-[var(--color-marca)] outline-none"
      />
    </div>
  );
}

// opciones: [{ valor, etiqueta }] o strings.
export function SelectFiltro({ valor, onChange, vacio, opciones, etiqueta }) {
  const norm = opciones.map((o) => (typeof o === 'string' ? { valor: o, etiqueta: o } : o));
  return (
    <select
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      // Sin esto, dos filtros seguidos se anuncian solo por el valor que
      // tienen puesto: «Todos los estados» y «Todos los tipos» no dicen
      // cuál de los dos es cuál cuando ya se eligió algo en ambos.
      aria-label={etiqueta || vacio}
      className="text-sm border border-gray-300 rounded-lg px-2.5 py-2 bg-white focus:border-[var(--color-marca)] focus:ring-2 focus:ring-[var(--color-marca)] outline-none"
    >
      {vacio !== undefined && <option value="">{vacio}</option>}
      {norm.map((o) => (
        <option key={o.valor} value={o.valor}>{o.etiqueta}</option>
      ))}
    </select>
  );
}

export function RangoFechas({ desde, hasta, onDesde, onHasta, etiqueta = 'Rango de fechas' }) {
  return (
    <div className="flex items-center gap-1 text-sm" role="group" aria-label={etiqueta}>
      {/* La «a» de en medio solo se ve. Cuál es el inicio y cuál el fin
          tiene que decirlo cada campo por su cuenta. */}
      <input type="date" value={desde || ''} onChange={(e) => onDesde(e.target.value)}
             aria-label={`${etiqueta}: desde`}
             className="border border-gray-300 rounded-lg px-2 py-1.5 bg-white" />
      <span className="text-gray-500" aria-hidden="true">a</span>
      <input type="date" value={hasta || ''} onChange={(e) => onHasta(e.target.value)}
             aria-label={`${etiqueta}: hasta`}
             className="border border-gray-300 rounded-lg px-2 py-1.5 bg-white" />
    </div>
  );
}
